export class Money {
  constructor(
    readonly currency: string,
    readonly amount: number,
  ) {}
}
